import React, { ReactNode } from 'react';
import { useStudyListSidebarLayout } from './useStudyListSidebarLayout';
import { Sidebar, useSidebarPresentation } from 'components/shared/Sidebar';

type Props = {
  children: ReactNode;
  closeButtonLabel: string;
  disclosureId: string;
  isOpen: boolean;
  onClose: () => void;
  onClosed?: () => void;
  panelRoot: HTMLElement;
  title: ReactNode;
  isCloseDisabled?: boolean;
  hasHeaderDivider?: boolean;
};

export type StudyListSidebarSharedProps = Pick<
  Props,
  'isOpen' | 'onClose' | 'onClosed' | 'panelRoot'
>;

export const sidebarHeadingId = (disclosureId: string) =>
  `${disclosureId}-heading`;

export const StudyListSidebar = ({ children, ...sidebarProps }: Props) => {
  // Handles whether sidebar content is docked to right side of the screen, or a modal which overlays the study list content
  const presentation = useSidebarPresentation();

  // Handles resizing the study list content to make room for sidebar content when it is docked
  const { panelRef, panelStyle } = useStudyListSidebarLayout({
    isDocked: presentation === 'docked',
    isOpen: sidebarProps.isOpen,
  });

  return (
    <Sidebar
      {...sidebarProps}
      headingId={sidebarHeadingId(sidebarProps.disclosureId)}
      panelRef={panelRef}
      panelStyle={panelStyle}
    >
      {children}
    </Sidebar>
  );
};
